import { useState } from 'react';

import { useIntl } from 'react-intl-next';
import { usePathParam } from 'react-resource-router';

import { useDefaultCatch } from '@atlassian/eoc-catch';
import { errorToastProps, successToastProps } from '@atlassian/eoc-common';
import { useFlags } from '@atlassian/eoc-global-context';

import { updateAutoCreationEndpoint } from '../endpoints';

import messages from './messages';

export const useAutoCreateService = () => {
	const [isAutoCreateUpdating, setAutoCreateUpdating] = useState(false);
	const [teamId] = usePathParam('teamId');

	const flagApi = useFlags();
	const intlApi = useIntl();
	const defaultCatch = useDefaultCatch();

	const updateAutoCreation = (autoCreateEnabled: boolean) => {
		setAutoCreateUpdating(true);

		return updateAutoCreationEndpoint(teamId, autoCreateEnabled)
			.then(() => {
				flagApi.showFlag({
					...successToastProps(),
					title: intlApi.formatMessage(messages.updateAutoCreationSuccessTitle, {
						isEnabled: autoCreateEnabled,
					}),
				});
			})
			.catch((e) => {
				defaultCatch(
					{
						id: 'updateAutoCreation',
						httpErrorHandler: (error) => {
							flagApi.showFlag({
								...errorToastProps(),
								description: error.message,
								title: intlApi.formatMessage(messages.updateAutoCreationErrorTitle, {
									isEnabled: autoCreateEnabled,
								}),
							});
						},
					},
					e,
				);

				throw e;
			})
			.finally(() => {
				setAutoCreateUpdating(false);
			});
	};

	return {
		isAutoCreateUpdating,
		updateAutoCreation,
	};
};
